export const validationTypes = {
  min: (value, rule) => value >= rule.value,
  max: (value, rule) => value <= rule.value,
  integer: (value) => Number.isInteger(value),
  string: (value) => typeof value === "string",
  boolean: (value) => typeof value === "boolean",
  custom: (value, rule) => rule.validate(value),
};

// MENSAJES DE VALIDACIÓN
export const VALIDATION_MESSAGES = {
  min: (value) => `Debe ser mayor a ${value}`,
  max: (value) => `Debe ser menor a ${value}`,
  integer: "Debe ser un número entero",
  string: "Debe ser una cadena de texto",
  boolean: "Debe ser un valor booleano",
  validYear: "Debe ser un año entre 1900 y el año actual",
  validDate: "Debe ser un formato de fecha válida (YYYY-MM-DD)",
};

export const VALIDATION_RULES = {
  min: (value) => ({
    type: "min",
    value,
    message: VALIDATION_MESSAGES.min(value),
  }),
  max: (value) => ({
    type: "max",
    value,
    message: VALIDATION_MESSAGES.max(value),
  }),
  integer: {
    type: "integer",
    message: VALIDATION_MESSAGES.integer,
  },
  string: {
    type: "string",
    message: VALIDATION_MESSAGES.string,
  },
  boolean: {
    type: "boolean",
    message: VALIDATION_MESSAGES.boolean,
  },
  validYear: {
    type: "custom",
    validate: (value) => value >= 1900 && value <= new Date().getFullYear(),
    message: VALIDATION_MESSAGES.validYear,
  },
  validDate: {
    type: "custom",
    validate: (value) => {
      // Si AG-Grid pasa un objeto Date (dataType: "date")
      if (value instanceof Date) {
        return !isNaN(value.getTime());
      }
      let normalized = value;
      // Acepta DD-MM-YYYY o DD/MM/YYYY y lo normaliza a YYYY-MM-DD
      const ddmmyyyy = /^(\d{2})[-/](\d{2})[-/](\d{4})$/;
      const matchDmy = ddmmyyyy.exec(value);
      if (matchDmy) {
        normalized = `${matchDmy[3]}-${matchDmy[2]}-${matchDmy[1]}`;
      }
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      if (!regex.test(normalized)) {
        return false;
      }
      const date = new Date(normalized);
      const isValidDate =
        !isNaN(date.getTime()) &&
        normalized === date.toISOString().split("T")[0];
      return isValidDate;
    },
    message: VALIDATION_MESSAGES.validDate,
  },
};
